import React from 'react';
import PropTypes from 'prop-types';

class StreamSelectMenu extends React.Component {
    static get propTypes() {
        return {
            streams: PropTypes.object,
            currentStream: PropTypes.string,
            onStreamChange: PropTypes.func
        };
    }

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const streamKey = event.target.value
        this.props.onStreamChange(streamKey)
    }

    render() {
        if (this.props.streams.length === 1) return null

        const streams = this.props.streams
        const currentStream = this.props.currentStream

        return (
            <div className="stream-select">
                <span>Tiešraides izvēle:</span>
                <select value={currentStream} onChange={this.handleChange}>
                    {
                        Object.keys(streams).map(function(key, index) {
                            return (
                                <option
                                    key={streams[key].channelId}
                                    value={streams[key].channelId}
                                >
                                    {streams[key].channelName}
                                </option>
                            );
                        })
                    }
                </select>
            </div>
        );
    }
}

export default StreamSelectMenu;